<template>
  <div class="hero">
    <div class="hero__bg-wrap">
      <div class="hero__bg">
        <div class="hero__bg-inner">
          <video
            class="hero__bg-video"
            loop
            playsinline
            autoplay
            muted
            @canplay="setVideoLoaded"
          >
            <source src="/video/hero.mp4">
          </video>
        </div>
      </div>
      <overlay-component/>
    </div>

    <div class="hero__content">
      <h1 class="hero__heading">
        <strong ref="mainTitle">Oficjalna mapa</strong>
        <span class="hero__text">
          <span class="hero__text-content" ref="secondaryTitle">
            nieoficjalnej Warszawy
          </span>
          <span class="hero__text-underline" ref="underline"/>
        </span>
      </h1>

      <div class="hero__lead">
        <div class="hero__lead-media">
          <hero-text
            :is-animatable="!isAnimationComplete"
            :animate="animate"
            @complete="handleAnimationComplete"
          />
        </div>
      </div>

      <div class="hero__btn-wrap" ref="btn">
        <button-component @click="handleButtonClick">
          Sprawdź
        </button-component>
      </div>
    </div>
    <rodo-info/>
  </div>
</template>

<script>
import anime from 'animejs'
import { mapMutations, mapState, mapGetters } from 'vuex'
import { SET_HERO_ANIMATION, SET_VIDEO_LOADED } from '@/store/mutation-types'

import ButtonComponent from '@/components/Button'
import OverlayComponent from '@/components/Overlay'
import HeroText from '@/components/HeroText'
import RodoInfo from '@/components/RodoInfo'

export default {
  components: {
    ButtonComponent,
    OverlayComponent,
    HeroText,
    RodoInfo
  },
  data () {
    return {
      animate: false,
      isTextAnimationComplete: false,
      areAllAnimationsComplete: false
    }
  },
  computed: {
    ...mapState(['isAnimationComplete']),
    ...mapGetters(['isLoading'])
  },
  watch: {
    isTextAnimationComplete () {
      if (this.isTextAnimationComplete && this.timeline) {
        this.timeline.play()
      }
    },
    isLoading () {
      if (!this.isLoading) {
        this.initializeAnimation()
      }
    }
  },
  mounted () {
    this.initializeAnimation()
  },
  methods: {
    ...mapMutations({
      setHeroAnimation: SET_HERO_ANIMATION,
      setVideoLoaded: SET_VIDEO_LOADED
    }),
    handleButtonClick () {
      /* eslint-disable */
      if (dataLayer) {
        dataLayer.push({ event: 'sprawdz' })
      }
      /* eslint-enable */
      this.$router.push({ name: 'map' })
    },
    handleAnimationComplete () {
      this.isTextAnimationComplete = true
    },
    initializeAnimation () {
      if (this.isAnimationComplete || this.isLoading) return

      setTimeout(() => {
        this.animate = true
      }, 350)

      const { mainTitle, secondaryTitle, underline, btn } = this.$refs

      this.timeline = anime.timeline({
        duration: 400,
        easing: 'easeInOutSine',
        autoplay: false
      })

      this.timeline
        .add({
          targets: mainTitle,
          opacity: [0, 1]
        })
        .add({
          targets: underline,
          width: ['0', '120%'],
          offset: '-=100'
        })
        .add({
          targets: secondaryTitle,
          opacity: [0, 1]
        })
        .add({
          targets: btn,
          translateY: [20, 0],
          opacity: [0, 1],
          duration: 600,
          offset: '+=175',
          complete: () => {
            this.areAllAnimationsComplete = true
            this.setHeroAnimation()
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .hero {
    position: fixed;
    top: 0;
    left: 0;

    width: 100vw;
    height: 100%;
    overflow: hidden;

    background-color: $accent-color;
    z-index: z(hero);

    &__bg-wrap,
    &__bg {
      @include full-size;
    }

    &__bg-inner {
      transform: scale(1.1);
      height: 100vh;
      background-color: $accent-color;
    }

    &__bg-video {
      @include center-self;

      min-width: 100%;
      min-height: 100%;
      mix-blend-mode: multiply;
    }

    &__content {
      @include center-self;

      padding: 60px 20px 20px;
      width: 100%;
      max-width: 400px;
      text-align: center;

      @include media-up(md) {
        max-width: 570px;
        padding-top: 90px;
      }

      @include media-up(lg) {
        padding-top: 110px;
      }

      @include media-up(xl) {
        max-width: 890px;
      }
    }

    &__heading {
      @include font($akrobat-font, 300);

      text-transform: uppercase;
      letter-spacing: 0.03em;

      font-size: 20px;

      strong {
        font-weight: 700;
        display: block;

        @include media-up(sm) {
          display: inline;
        }
      }

      @include media-up(xl) {
        font-size: 30px;
      }

      margin: 0;
      padding-bottom: 32px;
    }

    &__lead {
      padding-bottom: 15vh;

      @include media-up(lg) {
        padding-bottom: 20vh;
      }
    }

    &__lead-media {
      max-width: 100%;
      display: block;
    }

    &__text {
      position: relative;

      &-content {
        will-change: opacity;
      }

      &-underline {
        display: block;
        position: absolute;
        bottom: -2px;
        left: -10%;
        z-index: -1;

        height: 12px;
        width: 120%;
        background-color: $base-opposite-color;

        will-change: width;

        @include media-up(xl) {
          height: 24px;
          bottom: -8px;
        }
      }
    }

    &__btn-wrap {
      display: flex;
      justify-content: center;

      will-change: transform, opacity;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Hero.vue